module.exports = __webpack_public_path__ + "static/img/7.c6323de3.png";